import React from "react";
import {useAppSelector} from "../../../../../app/hooks";
import {FormContext} from "../../../../elements/validator/validatedForm/ValidatedForm";
import styles from "./TranscriptRoutingTab.module.css";
import {
    transcriptRoutingLocationsSelector,
    TranscriptRoutingSettingsUI
} from "./transcriptRoutingSlice";
import {TranscriptRoutingLocationCard} from "./TranscriptRoutingLocationCard";

interface TranscriptRoutingLocationsProps {
    formContext: FormContext<TranscriptRoutingSettingsUI>;
}

export const TranscriptRoutingLocations: React.FC<TranscriptRoutingLocationsProps> = ({formContext}) => {
    const locations = useAppSelector(transcriptRoutingLocationsSelector);

    return <div className={styles.locationList}>
        {locations.map((location, locationIndex) =>
            <TranscriptRoutingLocationCard
                key={location.locationPublicId}
                location={location}
                locationIndex={locationIndex}
                formContext={formContext}
            />
        )}
    </div>;
};
